import { INSURANCE_TYPES } from '@ratehub/ins-common';

import HOME_INSURANCE_QUOTE_LAUNCHER_MESSAGES from './HomeInsuranceQuoteLauncherMessages';


const HOME_INSURANCE_TYPE_OPTIONS = [
    {
        label: HOME_INSURANCE_QUOTE_LAUNCHER_MESSAGES.SELECT_HOME,
        value: INSURANCE_TYPES.HOME,
    },
    {
        label: HOME_INSURANCE_QUOTE_LAUNCHER_MESSAGES.SELECT_CONDO,
        value: INSURANCE_TYPES.CONDO,
    },
    {
        label: HOME_INSURANCE_QUOTE_LAUNCHER_MESSAGES.SELECT_TENANT,
        value: INSURANCE_TYPES.TENANT,
    },
];

export default HOME_INSURANCE_TYPE_OPTIONS;
